module.exports = __webpack_public_path__ + "static/media/WEB16.87aecf58.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/web/WEB16.jpg
// module id = 87
// module chunks = 0